import {HealthProviderLocation, NetworkTypesEnum} from 'domain/usecases';
import {makeGetHealthProviderLocationSupportAccredited} from 'main/factories/usecases/private/booking-flow/remote-health-booking/get-health-provider-location-support-accredited-factory';
import {parseHealthUnits} from '../../utils/parseHealthUnits';
import {GetHealthProviderLocationSupportAccreditedProps} from './types';

export async function getHealthProviderLocationSupportAccredited({
	params,
	signal,
}: GetHealthProviderLocationSupportAccreditedProps) {
	const healthSupportAccreditedUnits = await makeGetHealthProviderLocationSupportAccredited().get(
		{signal, ...params},
	);

	if (!healthSupportAccreditedUnits) {
		return [];
	}

	const accreditedUnitsList = healthSupportAccreditedUnits.unidades?.find(
		units => units.rede === NetworkTypesEnum.ACCREDITED,
	)?.unidadesPorLocal;
	const supportUnitsList = healthSupportAccreditedUnits.unidades?.find(
		units => units.rede === NetworkTypesEnum.SUPPORT,
	)?.unidadesPorLocal;

	const parsedSupportUnitsList = supportUnitsList
		? parseHealthUnits({
				units: supportUnitsList as HealthProviderLocation[],
				isAccreditedV2Network: false,
			})
		: [];

	const parsedAccreditedUnitsList = accreditedUnitsList
		? parseHealthUnits({
				units: accreditedUnitsList as HealthProviderLocation[],
				isAccreditedV2Network: true,
			})
		: [];

	const parsedList = [...parsedSupportUnitsList, ...parsedAccreditedUnitsList];

	return parsedList;
}
